import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import axios from "../axios";

import button_bg from '../images/button_bg.png'
import brand_district from '../images/district.png'
import bookmyshow from '../images/bookmyshow.png'
import sortmyscene from '../images/sortmyscene.jpg'
import skillbox from '../images/skillbox.png'
import scenes from '../images/scenes.jpg'
import logo from '../images/logo.png'
import banner from '../images/banner.png'

export default function Register() {
  const [ formData, setFormData ] = useState({ name: "", email: "", phone: "", dob: "" })

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("jwtToken");
    const role = localStorage.getItem("role");
    if (token && role) {
      navigate("/");
    }
  }, [navigate]);

  
  const inputBg = "bg-[#fbf8f2]";
  const inputBorder = "border border-[#39393b]";
  const inputRadius = "rounded-[10px]";

  async function handleSignUp(e) {
    e.preventDefault();
    setError("");
    
    setLoading(true);
    try {

      const res = await axios.post(`/register`, formData);
      setLoading(false);

      if (res.data.registrationId) {
        localStorage.setItem("rgId", res.data.registrationId);
        return navigate(`/ticket/${ res.data.registrationId }`);
      }

    } catch (err) {console.log(err.status)

      setLoading(false);
      return setError(err.status === 409 ? "Already registeredYou are already registered for this event." : JSON.stringify(err) );
    }
    
  }

  return (
    <div className="min-h-screenn flex flex-col items-center justify-start px-2" style={{ marginTop: "10rem" }}>
      
      <div className="mt-5" style={{ width: "20rem", height: "100%",  position: "relative" }}>
        <img src={banner} width={"100%"} height={"100%"} className="rounded-2xl"/>
      </div>

      <div className="mt-5" style={{ width: "20rem", height: "100%",  position: "relative" }}>
        <img src={button_bg} width={"100%"} height={"100%"} />
        <p className="text-[#fdf59f]" style={{ position: "absolute", textAlign: "center", width: "100%", top: "20%"}}>Register Now</p>
      </div>

      <p className="font-bold text-center text-[#3f0f06] ">Register for events and download qr code.</p>

       <div className="w-full flex justify-center mt-4">
        <Card
          className={`bg-[#18181ba8] rounded-[20px] border border-[#39393b] shadow-none w-[350px] max-w-[420px] relative overflow-hidden`}
          style={{ zIndex: 1 }}
        >

          <CardContent className="gap-6 flex flex-col relative z-10">
            <div className="flex flex-col items-center w-full justify-center">
              <img src={logo} width={"200px"} height={"100%"} />
              <p className="text-white font-bold text-center mt-2">Offline Management System</p>
            </div>
            {error && (
              <div className="text-red-500 text-center text-sm my-2">
                {error}
              </div>
            )}
           
              <form onSubmit={handleSignUp} className="flex flex-col gap-6">
                <div className="flex flex-col gap-2 mt-2">
                  <Label
                    htmlFor="signup-name"
                    className="text-white text-base font-semibold"
                  >
                    Name
                  </Label>
                  <Input
                    id="signup-name"
                    type="text"
                    autoComplete="name"
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className={`${inputBg} ${inputBorder} ${inputRadius} text-black text-base py-3 px-4`}
                    required
                  />
                </div>
                
                <div className="flex flex-col gap-2">
                  <Label
                    htmlFor="signup-name"
                    className="text-white text-base font-semibold"
                  >
                    Phone
                  </Label>
                  <Input
                    id="signup-phone"
                    type="number"
                    autoComplete="phone"
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    className={`${inputBg} ${inputBorder} ${inputRadius} text-black text-base py-3 px-4`}
                    required
                  />
                </div>

                <div className="flex flex-col gap-2">
                  <Label
                    htmlFor="signup-email"
                    className="text-white text-base font-semibold"
                  >
                    Email
                  </Label>
                  <Input
                    id="signup-email"
                    type="email"
                    autoComplete="email"
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className={`${inputBg} ${inputBorder} ${inputRadius} text-black text-base py-3 px-4`}
                  />
                </div>
                <div className="flex flex-col gap-2">
                  <Label
                    htmlFor="signup-dob"
                    className="text-white text-base font-semibold"
                  >
                    Date Of Birth
                  </Label>
                  <Input
                    id="signup-dob"
                    type="date"
                    autoComplete="new-dob"
                    onChange={(e) => setFormData({ ...formData, dob: e.target.value })}
                    className={`${inputBg} ${inputBorder} ${inputRadius} text-black text-base py-3 px-4 w-100`}
                    required
                  />
                </div>
                <Button
                  type="submit"
                  className="bg-white text-black text-[1.09rem] font-medium px-7 py-2 rounded-[10px] shadow-none hover:bg-[#ededed] transition-all duration-150"
                  style={{ boxShadow: "none" }}
                  disabled={loading}
                >
                  {loading ? "Registration..." : "Register"}
                </Button>

                <Link to={'/admin/login'} className="text-white text-center text-sm">Admin Login</Link>
              </form>
          </CardContent>
        </Card>
      </div>

      <p className="font-bold text-center text-[#3f0f06] mt-8">Tickets Are Live Now On!</p>

      <div className="flex flex-wrap justify-center items-center gap-3 pt-3 pb-5 mb-5">
        <div style={{ width: "7rem" }}>
          <img src={brand_district} style={{ width: "100%", aspectRatio: "3/1", mixBlendMode: "luminosity"}} />
        </div>
        <div style={{ width: "7rem" }}>
          <img src={bookmyshow} style={{ width: "100%", aspectRatio: "3/1",  mixBlendMode: "luminosity"}} />
        </div>
        <div style={{ width: "7rem" }}>
          <img src={sortmyscene} style={{ width: "100%", aspectRatio: "4/1",  mixBlendMode: "luminosity"}} />
        </div>
        <div style={{ width: "7rem" }}>
          <img src={skillbox} style={{ width: "100%", aspectRatio: "4/1",  mixBlendMode: "luminosity"}} />
        </div>
        <div style={{ width: "7rem" }}>
          <img src={scenes} style={{ width: "100%", aspectRatio: "3/1",  mixBlendMode: "luminosity"}} />
        </div>
      </div>
     
    </div>
  );
}
